"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("babel-types");
function handleBlock(body) {
    body.body.unshift(t.expressionStatement(t.callExpression(t.memberExpression(t.identifier("$S"), t.identifier("suspend")), [])));
}
function handleFunction(path) {
    if (path.node.mark === 'Flat') {
        return;
    }
    handleBlock(path.node.body);
}
const insertSuspend = {
    FunctionDeclaration(path) {
        handleFunction(path);
    },
    FunctionExpression(path) {
        handleFunction(path);
    },
    Loop(path) {
        if (path.node.body.type === "BlockStatement") {
            handleBlock(path.node.body);
        }
        else {
            const body = t.blockStatement([path.node.body]);
            path.node.body = body;
            handleBlock(body);
        }
    },
    Program: {
        exit(path, { opts }) {
            if (opts.compileFunction && !opts.eval) {
                if (path.node.body[0].type === 'FunctionDeclaration') {
                    path.node.body[0].topFunction = true;
                }
                else {
                    throw new Error(`Compile function expected top-level functionDeclaration`);
                }
            }
        }
    },
};
function default_1() {
    return { visitor: insertSuspend };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VzcGVuZFN0b3AuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc3RvcGlmeS9zdXNwZW5kU3RvcC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUNBLGlDQUFpQztBQUVqQyxTQUFTLFdBQVcsQ0FBQyxJQUFzQjtJQUN6QyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUMsbUJBQW1CLENBQ3JDLENBQUMsQ0FBQyxjQUFjLENBQUUsQ0FBQyxDQUFDLGdCQUFnQixDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsSUFBSSxDQUFDLEVBQ3JELENBQUMsQ0FBQyxVQUFVLENBQUMsU0FBUyxDQUFDLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDdEMsQ0FBQztBQU1ELFNBQVMsY0FBYyxDQUFDLElBQWtDO0lBQ3hELElBQVUsSUFBSSxDQUFDLElBQUssQ0FBQyxJQUFJLEtBQUssTUFBTSxFQUFFO1FBQ3BDLE9BQU87S0FDUjtJQUNELFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQzlCLENBQUM7QUFFRCxNQUFNLGFBQWEsR0FBWTtJQUM3QixtQkFBbUIsQ0FBQyxJQUFxQztRQUN2RCxjQUFjLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdkIsQ0FBQztJQUVELGtCQUFrQixDQUFDLElBQW9DO1FBQ3JELGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN2QixDQUFDO0lBRUQsSUFBSSxDQUFDLElBQXNCO1FBQ3pCLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxLQUFLLGdCQUFnQixFQUFFO1lBQzVDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQzdCO2FBQ0k7WUFDSCxNQUFNLElBQUksR0FBRyxDQUFDLENBQUMsY0FBYyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO1lBQ2hELElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztZQUN0QixXQUFXLENBQUMsSUFBSSxDQUFDLENBQUM7U0FDbkI7SUFDSCxDQUFDO0lBRUQsT0FBTyxFQUFFO1FBQ1AsSUFBSSxDQUFDLElBQXlCLEVBQUUsRUFBRSxJQUFJLEVBQUU7WUFDdEMsSUFBRyxJQUFJLENBQUMsZUFBZSxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRTtnQkFDckMsSUFBRyxJQUFJLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLEtBQUsscUJBQXFCLEVBQUU7b0JBQzdDLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBRSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUM7aUJBQzdDO3FCQUNJO29CQUNILE1BQU0sSUFBSSxLQUFLLENBQ2IseURBQXlELENBQUMsQ0FBQztpQkFDOUQ7YUFDRjtRQUNILENBQUM7S0FDRjtDQUNGLENBQUM7QUFFRjtJQUNFLE9BQU8sRUFBRSxPQUFPLEVBQUUsYUFBYSxFQUFDLENBQUM7QUFDbkMsQ0FBQztBQUZELDRCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ./dist/src/stopify/suspendStop.js
// module id = 820
// module chunks = 0